var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProduct = function SvgProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.808 19.229a1.25 1.25 0 0 0 .176-.636V1h4.883C31.045 1 32 1.955 32 3.133v27.734A2.133 2.133 0 0 1 29.867 33H2.133A2.133 2.133 0 0 1 0 30.867V3.133C0 1.955.955 1 2.133 1h4.883v17.741a1.253 1.253 0 0 0 .618 1.076 1.303 1.303 0 0 0 1.258.04L16 16.407l7.041 3.265a1.31 1.31 0 0 0 1.294.017c.196-.108.36-.267.473-.46Z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.143 15.735a.998.998 0 0 1-.516.87 1.04 1.04 0 0 1-1.029-.013L16 13.996l-5.65 2.744a1.038 1.038 0 0 1-1-.033.996.996 0 0 1-.492-.855V.953h14.286v14.782Z"
  })));
};
export default SvgProduct;